module.exports = __webpack_public_path__ + "static/media/AACE International Logo.59bc0354.png";